/* Swiper for the ORCA success stories — one card per view, mobile only.
   From 750 up the design is a plain grid, so the slider is created and destroyed
   on the breakpoint rather than running everywhere. The design has no arrows or
   dots, so there are none. */
(() => {
  const MOBILE = '(max-width: 749px)';

  const init = (root) => {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.stories__list').forEach((el) => {
      // the gap is declared in CSS as `column-gap` on the container (where it has
      // no layout effect of its own) purely so it resolves to pixels here
      const gap = () => parseFloat(getComputedStyle(el).columnGap) || 0;
      const mq = window.matchMedia(MOBILE);

      const sync = () => {
        if (mq.matches && !el.swiper) {
          new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: gap(),
            watchOverflow: true,
          });
        } else if (!mq.matches && el.swiper) {
          // second argument cleans the inline styles Swiper wrote on the slides
          el.swiper.destroy(true, true);
        }
      };

      mq.addEventListener('change', sync);
      sync();
    });
  };

  const start = () => init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
